export default function Experience(props) {
    return (
        <div className="exper">
            <article className="artExper">
                <i className={props.icon}></i>
            </article>
            <article className="contentExper">
                <p className="dateExper">{props.date}</p>
                <p className="titleExper">{props.title}</p>
                <p className="descExper">{props.desc}</p>
            </article>
        </div>
    );
}